module.exports = __webpack_public_path__ + "static/img/sex1.6f7eeb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sex1.png
// module id = bDR3
// module chunks = 5